import { render } from "./InAppRestorePurchasesEditorCmp.vue?vue&type=template&id=c4fbd78a"
import script from "./InAppRestorePurchasesEditorCmp.vue?vue&type=script&lang=js"
export * from "./InAppRestorePurchasesEditorCmp.vue?vue&type=script&lang=js"

import "./InAppRestorePurchasesEditorCmp.vue?vue&type=style&index=0&id=c4fbd78a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__